<template>
    <div v-if="isLoggedIn && memberClusterCode == 'stm'" class="container page">
        <!--
    **************************************************************************************************************************************************
                                                                N E W     I D E A
    **************************************************************************************************************************************************
    -->
        <section v-if="displayPart==-1" class="card card-default">
            <div class="col-sm-8"><h5>Santam CEO Awards is Closed</h5></div>
        </section>

        <section v-if="displayPart==10" class="card card-default">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-8"><h5>Santam CEO Awards Winners</h5></div>
                    <!--<div class="col-sm-4 text-right">
                    <a class="btn btn-primary" href="#" @click.prevent="displayPart=0">New CEO Award nomination</a>
                </div>-->
                </div>
            </div>
            <div class="card-body">
                <div><content-db contentKey="ceowinners" :isCache="true"></content-db></div>


                <!--<h3 class="text-center"><b>2020 WINNERS</b></h3>
            <div>&nbsp;</div>

            <div class="row text-center" style="font-size:smaller">
                <div class="col-sm-4 mb-3">
                    <div class="shadow-sm p-3 bg-white rounded text-center">
                        <img src="https://cdn.rewardedco.com/content/sanlam/ceoaward/ceowin2020-01.jpg" class="w-100" />
                    </div>-->
                <!-- names to go here -->
                <!--</div>
            <div class="col-sm-4 mb-3">
                <div class="shadow-sm p-3 bg-white rounded text-center">
                    <img src="https://cdn.rewardedco.com/content/sanlam/ceoaward/ceowin2020-02.jpg" class="w-100" />
                </div>-->
                <!-- names to go here -->
                <!--</div>
            <div class="col-sm-4 mb-3">
                <div class="shadow-sm p-3 bg-white rounded text-center">
                    <img src="https://cdn.rewardedco.com/content/sanlam/ceoaward/ceowin2020-03.jpg" class="w-100" />
                </div>-->
                <!-- names to go here -->
                <!--</div>
            <div class="col-sm-4 mb-3">
                <div class="shadow-sm p-3 bg-white rounded text-center">
                    <img src="https://cdn.rewardedco.com/content/sanlam/ceoaward/ceowin2020-04.jpg" class="w-100" />
                </div>-->
                <!-- names to go here -->
                <!--</div>
            <div class="col-sm-4 mb-3">
                <div class="shadow-sm p-3 bg-white rounded text-center">
                    <img src="https://cdn.rewardedco.com/content/sanlam/ceoaward/ceowin2020-05.jpg" class="w-100" />
                </div>-->
                <!-- names to go here -->
                <!--</div>
            <div class="col-sm-4 mb-3">
                <div class="shadow-sm p-3 bg-white rounded text-center">
                    <img src="https://cdn.rewardedco.com/content/sanlam/ceoaward/ceowin2020-06.jpg" class="w-100" />
                </div>-->
                <!-- names to go here -->
                <!--</div>
            <div class="col-sm-4 mb-3">
                <div class="shadow-sm p-3 bg-white rounded text-center">
                    <img src="https://cdn.rewardedco.com/content/sanlam/ceoaward/ceowin2020-07.jpg" class="w-100" />
                </div>-->
                <!-- names to go here -->
                <!--</div>
            <div class="col-sm-4 mb-3">
                <div class="shadow-sm p-3 bg-white rounded text-center">
                    <img src="https://cdn.rewardedco.com/content/sanlam/ceoaward/ceowin2020-08.jpg" class="w-100" />
                </div>-->
                <!-- names to go here -->
                <!--</div>
            <div class="col-sm-4 mb-3">
                <div class="shadow-sm p-3 bg-white rounded text-center">
                    <img src="https://cdn.rewardedco.com/content/sanlam/ceoaward/ceowin2020-09.jpg" class="w-100" />
                </div>-->
                <!-- names to go here -->
                <!--</div>


            </div>-->
                <!--<div><i>(There are currently no winners - watch this space!)</i></div>-->
                <hr />
                <!--<div class="text-center mt-5">
                <a class="btn btn-primary" href="#" @click.prevent="displayPart=0">New CEO Award nomination</a>
            </div>-->
            </div>
        </section>


        <section v-if="displayPart==2" class="card card-default">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-8"><h5>Santam CEO Awards</h5></div>
                    <div class="col-sm-4 text-right">
                        <a class="btn btn-primary" href="#" @click.prevent="showNomForm()">New CEO Award nomination</a>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="nomMessage">
                    <b-card no-body>
                        <b-tabs pills vertical lazy card no-nav-style nav-wrapper-class="col-12 col-md-4" content-class="col-12 col-md-8">
                            <b-tab>
                                <template v-slot:title>
                                    <div class="text-center"><b-img thumbnail fluid :src="require('../assets/image/SantamCeoAwardTava.png')" alt=""></b-img></div>
                                    <div class="mb-1 text-center ceo">Tava</div>
                                </template>
                                <b-card-text class="text-left">
                                    <p>Dear Colleagues</p>
                                    <p>At Santam, our success is shaped by the people who go the extra mile, those who demonstrate care, lead with purpose, and consistently make a meaningful difference.</p>
                                    <p>I invite you to recognise and celebrate these individuals and teams by nominating them for the Santam CEO Awards. This is an opportunity to honour colleagues who inspire those around them and embody our values in the way they lead, collaborate, innovate, and serve our clients.</p>
                                    <p>
                                        The nomination categories are:
                                        <div class="text-center"><b-img thumbnail fluid :src="require('../assets/image/SantamCeoAwardCats.png')" alt=""></b-img></div>
                                    </p>
                                    <p>Nominations close on 14 August 2026.</p>
                                    <p>Let us take this moment to acknowledge the exceptional contributions across our business and celebrate the people who make Santam what it is.</p>
                                    <p>Warm regards,</p>
                                    <p>Tava</p>
                                    <p>Santam</p>
                                </b-card-text>
                            </b-tab>

                            <hr />
                            <div v-if="false" class="mb-3 text-center"><strong>Nominations are now closed</strong></div>
                            <div v-else class="text-right mt-3 mb-3">
                                <a class="btn btn-primary" href="#" @click.prevent="showNomForm()" v-b-tooltip.hover.left title="Create a new Santam CEO Awards nomination">New Santam CEO Awards nomination</a>
                            </div>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </section>

        <template v-if="displayPart==0">
            <div class="row mb-2">
                <div class="col-sm-8">
                    <h5>Santam CEO Awards</h5>
                    Select an Award below, then complete your nomination.
                </div>
                <!--<div class="col-sm-4 text-right">
                <a href="#" @click.prevent="" class="btn btn-secondary">Back</a>
            </div>-->
            </div>
            <!--
        { value: '', text: '--- Please select an option ---' },
        { value: 'Individual', text: 'Individual' },
        { value: 'Team', text: 'Team' },
        { value: 'Innovation', text: 'Innovation' },
        { value: 'Young Achiever Award', text: 'Young Achiever Award < 35' },
        { value: 'General employee', text: 'General employee (non-management)' },
            -->
            <section class="card mb-4 nomAwardCategory3">
                <b-tabs v-model="tabIndex" lazy card nav-class="selcatNav">
                    <b-tab title="Leadership Award" @click="awardCatSelected('Leadership Award')">
                        <b-card-text class="text-left">
                            <h3>Leadership Award</h3>
                            <hr />
                            <p>This individual award acknowledges exemplary leadership that has had a significant and positive impact on profit and growth or delivered solutions in line with our business strategy.</p>
                            <p>Leading with clarity in uncertain times is worthy of being recognised and celebrated.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Innovation Award" @click="awardCatSelected('Innovation Award')">
                        <b-card-text class="text-left">
                            <h3>Innovation Award</h3>
                            <hr />
                            <p>This award celebrates an individual (or team) making change work for them and for their business.</p>
                            <p>The achievement of improving or replacing a product, service or business process whilst adding value to the lives of others should be recognised and celebrated.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Client Centric Award" @click="awardCatSelected('Client Centric Award')">
                        <b-card-text class="text-left">
                            <h3>Client Centric Award</h3>
                            <hr />
                            <p>Celebrating an individual (or team) who embody our promise of “Freedom” to our clients and other stakeholders.</p>
                            <p>Working to deliver on our promise, whilst creating value and growth for the Group is worthy of recognition.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Everyday Hero Award" @click="awardCatSelected('Everyday Hero Award')">
                        <b-card-text class="text-left">
                            <h3>Everyday Hero Award</h3>
                            <hr />
                            <p>Recognising an employee who may not be in a senior or formal leadership position, but who leads from within. </p>
                            <p>This employee sees opportunity where others may see obstacles.</p>
                            <p>Spotting opportunity and inspiring others to work with you to turn opportunity into growth is worthy of being recognised and celebrated.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Living Purposefully Award" @click="awardCatSelected('Living Purposefully Award')">
                        <b-card-text class="text-left">
                            <h3>Living Purposefully Award</h3>
                            <hr />
                            <p>This award celebrates an individual (or team) whose contribution has had a significant and positive impacted on their community and society.</p>
                            <p>Their state of social conscience and selflessness is worthy of being recognized.</p>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Young Achiever Award" @click="awardCatSelected('Young Achiever Award')">
                        <b-card-text class="text-left">
                            <h3>Young Achiever Award</h3>
                            <hr />
                            <p>
                                An employee, below 35 years, honoured for creating considerable value and who embraces
                                opportunities for growth. This award also recognises an employee who builds their own
                                brand as well as that of the business they represent and is seen as inspirational in their
                                field of expertise.
                            </p>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </section>

            <section class="card card-default mt-3" v-if="fNomination.form.awardCat !== null">
                <div class="card-header">
                    <h5>Nomination for: <b class="darkShade">{{ fNomination.form.awardCat }}</b></h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6"><strong>Nominee{{isNomSingleOnly ? "" : "s"}}:</strong></div>
                        <div class="col-sm-6 text-right"></div>
                    </div>
                    <div v-for="r in selectedNominees" :key="r._rowNum" class="row">
                        <template v-if="r.isEntireDivision">
                            <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                            <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                        </template>
                        <template v-else>
                            <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                            <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                            <div class="col">{{ r.division }}</div>
                        </template>
                    </div>
                    <div v-if="selectedNominees.length===0" class="text-danger">Please select nominee{{isNomSingleOnly ? "" : "s"}}.</div>
                    <div class="mt-1">
                        <b-button type="button" pill @click="$bvModal.show('modalChooseNominees')" variant="primary" size="sm">{{selectedNominees.length===0 ? 'Select' : 'Update'}}  Nominee{{isNomSingleOnly ? "" : "s"}}</b-button>
                        <!--<a href="#" @click.prevent="$bvModal.show('modalChooseNominees')">Select Nominees</a>-->
                    </div>

                    <hr />
                    <b-form @submit.prevent="onSubmitCEOaward" novalidate>

                        <!--<b-form-group id="groupMotivation" label-for="txtMotivation" label="Motivation:" :invalid-feedback="fNomination.errors.motivation" :description="1500-fNomination.form.motivation.length + ' characters remaining'">
                        <b-form-textarea id="txtMotivation" v-model="fNomination.form.motivation" :state="fNomination.state.motivation" placeholder="Provide a short motivation" rows="3" max-rows="5" maxlength="1500" />
                    </b-form-group>

                    <b-form-group id="groupActions" label-for="txtActions" label="Actions Taken" :invalid-feedback="fNomination.errors.actions" :description="1500-fNomination.form.actions.length + ' characters remaining'">
                        <b-form-textarea id="txtActions" v-model="fNomination.form.actions" :state="fNomination.state.actions" placeholder="Describe actions taken" rows="3" max-rows="5" maxlength="1500" />
                    </b-form-group>

                    <b-form-group id="groupMeasures" label-for="txtMeasures" label="Impact" :invalid-feedback="fNomination.errors.measures" :description="1500-fNomination.form.measures.length + ' characters remaining'">
                        <b-form-textarea id="txtMeasures" v-model="fNomination.form.measures" :state="fNomination.state.measures" placeholder="Impact thereof" rows="3" max-rows="5" maxlength="1500" />
                    </b-form-group>-->


                        <b-form-group id="groupMotivation" label-for="txtMotivation" label="Why should this person or team be nominated?" :invalid-feedback="fNomination.errors.motivation" :description="1500-fNomination.form.motivation.length + ' characters remaining'">
                            <b-form-textarea id="txtMotivation" v-model="fNomination.form.motivation" :state="fNomination.state.motivation" placeholder="" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupActions" label-for="txtActions" label="How did the nominated individual and/or team create meaningful value, improve outcomes, or identify a growth opportunity? Alternatively how did their actions mitigate substantial loss for the Santam Group?" :invalid-feedback="fNomination.errors.actions" :description="1500-fNomination.form.actions.length + ' characters remaining'">
                            <b-form-textarea id="txtActions" v-model="fNomination.form.actions" :state="fNomination.state.actions" placeholder="" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupMeasures" label-for="txtMeasures" label="How can the value or impact created by the nominee (and/or team) be practically measured for the Santam Group or through their contribution to the community in line with the Living Purposefully Award?" :invalid-feedback="fNomination.errors.measures" :description="1500-fNomination.form.measures.length + ' characters remaining'">
                            <b-form-textarea id="txtMeasures" v-model="fNomination.form.measures" :state="fNomination.state.measures" placeholder="" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupAchievements" label-for="txtAchievements" label="How do the achievements of the nominated individual (and/or team) support the Santam Group business strategy and/or create meaningful impact within the community?" :invalid-feedback="fNomination.errors.achievements" :description="1500-fNomination.form.achievements.length + ' characters remaining'">
                            <b-form-textarea id="txtAchievements" v-model="fNomination.form.achievements" :state="fNomination.state.achievements" placeholder="" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>


                        <hr />
                        <hr />
                        <div class="row">
                            <div class="col-sm-6"><strong>Seconders to support your nomination:</strong></div>
                            <div class="col-sm-6 text-right"></div>
                        </div>
                        <div v-for="r in selectedNominators" :key="r._rowNum" class="row">
                            <template v-if="r.isEntireDivision">
                                <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                                <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                            </template>
                            <template v-else>
                                <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                                <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                                <div class="col">{{ r.division }}</div>
                            </template>
                        </div>
                        <div v-if="selectedNominators.length!==2" class="text-danger">Please select two seconders to support your nomination.</div>
                        <div class="mt-1"><b-button type="button" pill @click="$bvModal.show('modalChooseNominators')" variant="primary" size="sm">{{selectedNominators.length===0 ? 'Select' : 'Update'}} Seconders</b-button></div>
                        <!--<div class="text-center"><b-button type="button" @click="$bvModal.show('modalChooseNominators')" variant="primary">Select Nominators</b-button></div>-->
                        <hr />
                        <div class="text-right"><b-button type="submit" variant="primary">Submit</b-button></div>
                    </b-form>
                </div>
            </section>
        </template>

        <section v-if="displayPart==1" class="card card-default">
            <div class="card-header">
                <h5>Santam CEO Awards</h5>
            </div>
            <div class="card-body">
                <b-alert variant="success" show>
                    <h4 class="alert-heading">Santam CEO Awards Nomination</h4>
                    <p>
                        Successfully submitted the Santam CEO Awards Nomination.
                    </p>
                </b-alert>

                <!--<b-button type="button" pill @click="displayPart=10" variant="primary">Ok</b-button>-->

            </div>
        </section>



        <!--
    **************************************************************************************************************************************************
                                                                M O D A L S
    **************************************************************************************************************************************************
    -->
        <!-- Modal - Nominees -->
        <b-modal id="modalChooseNominees" :title="'NOMINEE' + (isNomSingleOnly ? '' : 'S')" hide-footer size="xl" no-close-on-backdrop>
            <member-select :title="'Select Nominee' + (isNomSingleOnly ? '' : 's') + ' for the ' + fNomination.form.awardCat"
                           :selectedTitle="isNomSingleOnly ? 'Selected nominee' : 'Selected nominees'"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedNominees"
                           :isCountryFixed="true"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           :isSingle="isNomSingleOnly"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominees')">Done</b-button></div>
        </b-modal>



        <!-- Modal - Nominators -->
        <b-modal id="modalChooseNominators" title="NOMINATORS" hide-footer size="xl" no-close-on-backdrop>
            <member-select title="Select two seconders to support your nomination"
                           selectedTitle="Selected seconders to support your nomination"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedNominators"
                           :isCountryFixed="true"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           excludeDivisionCode="ra_7090,ra_7091"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominators')">Done</b-button></div>
        </b-modal>


    </div>

</template>

<script>
    // @ is an alias to /src
    //import HelloWorld from '@/components/HelloWorld.vue'
    //import SitecodeImage from '@/components/SitecodeImage';
    import axios from 'axios'
    //import sjData from '@/sjUtilData'
    import MemberSelect from '@/components/MemberSelect';
	import ContentDb from '@/components/ContentDb';



    export default {
        name: 'CEOaward',
        components: { MemberSelect, ContentDb },
        data() {
            return {
                displayPart: null, // NB - SET in  onCreated()    

				fNomination: { //*** NB: isGroupCeoAward is false if Cluster CEO Award
					form: { isGroupCeoAward: false, awardCat: '', achievements: '', motivation: '', actions: '', measures: '' }
                },
                tabIndex: 0,

                selectedNominees: [],
                selectedNominators: [],

                roles: { ca: false, cc: false, idea: false, inv: false },

                reportTitle: '',
                currentIdeaRowNum: null,
                modalPart: 0,

                awardCatList: [
                    { value: '', text: '--- Please select an option ---' },
					{ value: 'Leadership Award', text: 'Leadership Award' },
					{ value: 'Innovation Award', text: 'Innovation Award' },
					{ value: 'Client Centric Award', text: 'Client Centric Award' },
					{ value: 'Everyday Hero Award', text: 'Everyday Hero Award' },
                    { value: 'Living Purposefully Award', text: 'Living Purposefully Award' },
                    { value: 'Young Achiever Award', text: 'Young Achiever Award' },

					//{ value: 'Individual', text: 'Individual' },
					//{ value: 'Team', text: 'Team' },
                ]

            }
        },
        computed: {
            isLoggedIn() {
				return this.$store.state.isLoggedIn && this.memberDivisionCode != 'ra_7090' //Disable SanPay division from access
            },
            countryList() {
                if (this.isCountryFixed) { //only show the default cluster.
                    return this.$store.state.countryList.filter(country => country.countryCode === this.defaultCountryCode);
                } else {
                    return [{ countryCode: null, country: '-- Please select a Cluster--', disabled: true }]
                        .concat(this.$store.state.countryList);
                }
            },
            memberClusterCode() {
                return this.$store.state.memberStore.member.clusterCode
            },
            memberDivisionCode() {
                return this.$store.state.memberStore.member.divisionCode
            },
            currentIdea() {
                if (this.currentIdeaRowNum === null) return null;
                return this.ideas[this.currentIdeaRowNum];
            },
            isNomSingleOnly() {
                switch (this.fNomination.form.awardCat) {
                    case "Young Achiever Award":
                    case "Everyday Hero Award":
                    case "Leadership Award":
                        return true; //single
                    default:
                        return false; //team
                }


                return false;// !this.fNomination.form.awardCat.startsWith("Innovation Award");

                //return this.fNomination.form.awardCat == 'Leadership with Excellence'
                //    || this.fNomination.form.awardCat == 'Rising Star'
                //    || this.fNomination.form.awardCat == 'Everyday Hero';
            },
        },
        created() {
            //formSetState must be called on creation, to ensure all fields are setup
            this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm

            this.$store
                .dispatch('getDivisionList', {})
                .then(() => {
                    this.displayPart = -1; //-1: Closed, 2: Welcome page  0:Open  10:Show Winners (from content) [*** Also change santamCEOAwardStatus in AwardNomination.vue, and banner on home.vue] 
                    //this.showNomForm();
                })
                .catch((error) => {
                    this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error)));
                });


        },
        mounted() {

        },
        methods: {
            showNomForm() {
                this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm
                this.displayPart = 0;
                this.$nextTick(() => {
                    this.tabIndex = 0; //Select first tab
                    this.awardCatSelected('Leadership Award'); //ensure got awardCat for first tab
                });
            },

            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            },

            //*** formStatusUpdate - used to display form errors.
            //Ensure this.form contains the list of fields.
            //Call  formStatusUpdate(true) to initialise/clear the form errors.
            //formObject is the object that contains the following objects:  .form, .formState, .formErrors
            formSetState(formObj, resetState, resetForm) {
                if (typeof resetState === 'undefined') resetState = false;
                if (typeof resetForm === 'undefined') resetForm = false;
                if (typeof formObj.init === 'undefined') formObj.init = { ...formObj.form }; //Initialise .formInit object to be a copy of .form object.
                if (typeof formObj.errors === 'undefined') this.$set(formObj, 'errors', {}); //use this.$set  to make errors object reactive
                if (typeof formObj.state === 'undefined') this.$set(formObj, 'state', {});   //use this.$set  to make state object reactive

                if (resetState || resetForm) {
                    if (resetForm) formObj.form = { ...formObj.init }; //copy .init to .form

                    formObj.errors = {}; //reset formErrors object
                    formObj.state = {};
                }

                //update formState
                var fields = Object.getOwnPropertyNames(formObj.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (resetState) {
                        formObj.state[field] = null;
                    } else if (typeof formObj.errors[field] === 'undefined' || formObj.errors[field] === '') {
                        formObj.state[field] = true;
                    } else {
                        formObj.state[field] = false;
                    }
                }
            },

            awardCatSelected(awardCat) {
                let awardCats = this.awardCatList.map(e => { return e.value; });

                if (!awardCats.includes(awardCat)) {
                    this.msgBox('Cannot find "' + awardCat + '" in [' + awardCats.join(', ') + ']!');
                    return;
                }

                this.fNomination.form.awardCat = awardCat;
                this.selectedNominees = [];

                //this.tabSelected = true;
            },

            onSubmitCEOaward() {
                this.formSetState(this.fNomination, true);//formObj, resetState, resetForm
                this.fNomination.form.nominees = this.selectedNominees.map(item => item.isEntireDivision ? 'div:' + item.entireDivisionCode : item.memberId);

                let nominators = this.selectedNominators.filter(item => !item.isEntireDivision);
                if (this.selectedNominees.length === 0) {
                    this.msgBox('Please select at least one nominee.', 'Nominees are required');
                    return;
                }
                if (this.isNomSingleOnly && this.selectedNominees.length !== 1) {
                    this.msgBox('Only a single nominee may be selected.', 'Single Nominees');
                    return;
                }
                if (nominators.length !== 2) {
                    this.msgBox('Please select two seconders to support your nomination.', 'Two seconders are required');
                    return;
                }

                this.fNomination.form.nominatorMemberId1 = nominators[0].memberId;
                this.fNomination.form.nominatorMemberId2 = nominators[1].memberId;

                return axios
                    .post(
                        '/api/groupceoaward/newnomination',
                        this.fNomination.form
                    )
                    .then(({ data }) => {
                        this.displayPart = 1;
                        //this.msgBox('Successfully submitted nomination');
                    })
                    .catch((error) => {
                        this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error.response.data)));
                        if (error.response.data.formErrors) {
                            this.fNomination.errors = error.response.data.formErrors;
                            this.formSetState(this.fNomination);
                        }
                    })
                    ;
            },

        }




    }
</script>
